// extracted by mini-css-extract-plugin
module.exports = {"root":"ReportDetails_root__20Qmj","header":"ReportDetails_header__GSmnP","title":"ReportDetails_title__1fm1v","left":"ReportDetails_left__1RDBr"};